import Typography from '@mui/material/Typography';
import { Toggle, Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTCLI_No,
  TXTCLI_Yes,
  TXTWCL_Are_you_acting_on_behalf_of_a__ELL
} from './ThirdParty.messages.json';
import { wrapper } from './ThirdParty.scss';

const ThirdParty: React.FC = () => (
  <>
    <Typography>
      <Translation {...TXTWCL_Are_you_acting_on_behalf_of_a__ELL} />
    </Typography>
    <div className={wrapper}>
      <Toggle
        id="yes"
        name="thirdParty"
        label={TXTCLI_Yes}
        type="radio"
        value="yes"
        data-testid="thirdPartyYesId"
      />
      <Toggle
        id="no"
        name="thirdParty"
        label={TXTCLI_No}
        type="radio"
        value="no"
        data-testid="thirdPartyNoId"
      />
    </div>
  </>
);

export default ThirdParty;
